import $ from 'jquery';
import Menu from './Menu';
import Viewport from './Viewport';

export default class TermNavigation {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.viewport = new Viewport();
    this.onHeaderClick = $.proxy(this.onHeaderClick, this);
    this.standardize();
    this.addMenu();
    this.addPatties();
    this.listen();
    this.ready();
  }

  standardize() {
    this.$element.find('li.expanded, li.collapsed')
      .removeClass('expanded collapsed')
      .addClass('menuparent');
  }

  addMenu() {
    this.menu = new Menu(this.element);
  }

  onHeaderClick(event) {
    if (this.viewport.mobileState) {
      event.preventDefault();
      this.$element.toggleClass('expand-mobile-menu');
    }
  }

  addPatties() {
    const patties = '<span class="patty"></span><span class="patty"></span><span class="patty"></span>';
    this.$element.find('.block-title a').prepend(patties);
  }

  listen() {
    // Add a click handler to control the mobile dropdown menu
    this.$element.find('.block-title a').on('click', this.onHeaderClick);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
